import { ICON_HEIGHT, ICON_WIDTH } from "../default/default.constants";
const ICON_FAMILY_NAVIGATION = "navigation";
export { ICON_FAMILY_NAVIGATION, ICON_WIDTH, ICON_HEIGHT };
